import { render } from "./ListeTransfert.vue?vue&type=template&id=703018e5&ts=true"
import script from "./ListeTransfert.vue?vue&type=script&lang=ts"
export * from "./ListeTransfert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__